export const customQueryFn = async (
  request: RequestInfo & {
    meta: {
      endpoint: string;
      cacheName: string;
      errorMessage: string;
      mutateResponse: (response: Response) => Promise<Response>;
    };
  }
) => {
  const {
    meta: { endpoint, cacheName, errorMessage, mutateResponse },
  } = request;
  const cache = await caches.open(cacheName);
  try {
    const response = await fetch(endpoint, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok)
      throw new Error(`${errorMessage}. Status: ${response.status}`);
    try {
      const cachedData = await mutateResponse(response);
      const jsonResponse = await response.json();
      await cache.put(request, cachedData.clone());
      return jsonResponse.data.info;
    } catch {
      await cache.put(request, response.clone());
      return response.json();
    }
  } catch (err) {
    const cachedResponse = await cache.match(request);
    if (cachedResponse) {
      const cachedData = await cachedResponse.json();
      return cachedData;
    } else {
      throw new Error(`${errorMessage}. Message: ${(err as Error).message}`);
    }
  }
};
